<template>
    <div class="container">
        <div class="card">
            <div class="card-header">
                <h1 class="mb-0">Glossar</h1>
            </div>
            <div class="card-body">
                <div class="wpb_wrapper">
                    <input
                        class="form-control lexicon-search"
                        autocomplete="off"
                        v-model="search"
                        placeholder="Suche.."
                    />
                    <hr />
                    <div class="btn-group-sm" role="group">
                        <a
                            v-for="letter in glossaryLetters"
                            :key="letter"
                            type="button"
                            class="btn btn-sm btn-default lexicon-char-link"
                            :href="'#char-' + letter">
                            {{letter}}
                        </a>
                    </div>
                    <hr />
                    <div class="lexicon-container">
                        <div v-for="(entries, letter) in glossaryGroups" :key="letter" class="lexicon-entry">
                            <div class="h1">
                                <span class="lexicon-char" :id="'char-' + letter">{{ letter }}</span>
                            </div>
                            <div v-for="entry in entries" :key="entry.id" class="row mb-2">
                                <div class="col-md-6 lexicon-key">{{ entry.name }}</div>
                                <div class="col-md-6 lexicon-value">
                                    <ul class="list-unstyled mb-1">
                                        <li v-for="title in entry.titles" :key="title">{{ title }}</li>
                                    </ul>
                                </div>
                                <div v-if="hasContent(entry.text) || hasContent(entry.text_danger) || hasContent(entry.text_additional)" class="px-4 pb-2 col-12">
                                    <div v-if="hasContent(entry.text)" class="lexicon-text mt-2 col-12 bg-light p-2 text-grey">
                                        <small class="text-muted block">Allgemeine Informationen:</small>
                                        <div v-html="entry.text" class="mb-0 lexicon-text-entry"></div>
                                    </div>
                                    <div v-if="hasContent(entry.text_danger)" class="lexicon-text-danger mt-2 col-12 bg-light p-2 text-grey">
                                        <small class="text-muted block">Gefahrstoffhinweise:</small>
                                        <div v-html="entry.text_danger" class="mb-0 lexicon-text-entry"></div>
                                    </div>
                                    <div v-if="hasContent(entry.text_additional)" class="lexicon-text-additional mt-2 col-12 bg-light p-2 text-grey">
                                        <small class="text-muted block">Zusatzinformationen:</small>
                                        <div v-html="entry.text_additional" class="mb-0 lexicon-text-entry"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        glossaryFetchUrl: String
    },
    data() {
        return {
            search: '',
            glossaries: []
        };
    },
    computed: {
        glossaryLetters() {
            return _.keys(this.glossaryGroups);
        },
        glossaryGroups() {
            return _.groupBy(this.glossaryItems, (item) => {
                return item.name.charAt(0).toUpperCase();
            });
        },
        glossaryItems() {
            const grouped = {};

            this.glossaries.forEach((g) => {
                g.types.forEach((t) => {
                    if (!this.search.length || t.name.toLowerCase().includes(this.search.toLowerCase())) {
                        if (!grouped[t.id]) {
                            grouped[t.id] = {
                                id: t.id,
                                name: t.name,
                                text: t.text,
                                text_danger: t.text_danger,
                                text_additional: t.text_additional,
                                titles: []
                            };
                        } else {
                            // Take first non-null value for text fields
                            grouped[t.id].text = grouped[t.id].text ?? t.text;
                            grouped[t.id].text_danger = grouped[t.id].text_danger ?? t.text_danger;
                            grouped[t.id].text_additional = grouped[t.id].text_additional ?? t.text_additional;
                        }
                        grouped[t.id].titles.push(g.title);
                    }
                });
            });

            return _.sortBy(Object.values(grouped), 'name');
        }
    },
    mounted() {
        axios.get(this.glossaryFetchUrl).then((response) => {
            this.glossaries = response.data.data;
        });
    },
    methods: {
        hasContent(value) {
            if (!value) return false;
            return value.replace(/<[^>]*>/g, '').trim().length > 0;
        }
    }
}
</script>

<style scoped>
.lexicon-text-entry > p:last-child {
    margin-bottom: 0;
}
</style>